var _path, _circle, _path2, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorrowInterestPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E44E4E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m8 21.429 1.08-.454a8.228 8.228 0 0 1 4.79-.485l1.47.293a4.54 4.54 0 0 1 2.86 1.884v0M8 27.143l.131-.032a6.949 6.949 0 0 1 4.332.346v0a6.95 6.95 0 0 0 2.692.543h.17a7.798 7.798 0 0 0 4.311-1.3l4.814-3.192a1.23 1.23 0 0 0 .55-1.026v0a1.23 1.23 0 0 0-1.041-1.216l-.402-.063a1.707 1.707 0 0 0-.763.055L18.2 22.667m0 0L13.754 24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 6,
    stroke: "#DF3030",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E44E4E",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M14 11.939 17.939 8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 8,
    r: 0.5,
    fill: "#F1A7A7",
    stroke: "#F1A7A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 12,
    r: 0.5,
    fill: "#F1A7A7",
    stroke: "#F1A7A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowInterestPaid);
export default __webpack_public_path__ + "static/media/borrowInterestPaid.6d0f3c4a6a9050d7346833e863e06226.svg";
export { ForwardRef as ReactComponent };